import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;

        return (
            <div>
                <h3><center><u>Goods Transfer Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>

                {keys.map((e, index) => {
                    return (
                        <div key={index} className="row pt-2">

                            <div className="col width1"><p><b><p />GTN number:</b><br /><br />  {data[e][0].gtnNumber}</p> </div>
                            <div className="col width3"><p><b><p />Division Name </b><br /><br />{data[e][0].collectionPointName} </p> </div>
                            <div className="col width3"><p><b><p />Transferred To </b><br /><br />{data[e][0].transferedTo}</p> </div>
                            <div className="colwidth3"> <p><b><p />Transfer Note:</b><br /><br />  {data[e][0].transferNote}</p></div>
                            <div className="col width4">

                                <table className="display dataTable no-footer" id={e}>
                                    <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Total Amount (Kg)</th>
                                            <th>Deduction (Kg)</th>
                                            <th>Net Amount (Kg)</th>
                                            <th>Bag Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentWithoutEdit
                                            data={data[e]}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}